/**
 * @prettier
 * @flow
 */
import { BigNumber } from 'bignumber.js';
import { getLanguage } from 'src/utils/translate/language';

export function formatAsCurrency(number?: ?string | number): string { // TODO: Return maybe type
    if (!number) {
        return '';
    }
    const fractionDigits = BigNumber(number).toString().includes('.') ? 2 : 0;
    return Intl.NumberFormat(getLanguage(), {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'MXN',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    })
        .format((number: any)) + ' MXN';
}
